import postawaImage from "../../assets/POSTAWA.png";
import mowaImage from "../../assets/MOWA.png";
import gestImage from "../../assets/GEST.png";
import chodImage from "../../assets/CHOD.png";
import bluered from "../../assets/blue-red.png";
import bluegreen from "../../assets/blue-green.png";
import blueblue from "../../assets/blue-blue.png";
import blueyellow from "../../assets/blue-yellow.png";
import t, { tImage } from "../../translations";

export default [
  {
    title: t("blue_section_one_title"),
    subSections: [
      {
        title: t("blue_subsection_one_title"),
        description: [
          t("blue_subsection_one_description_one"),
          t("blue_subsection_one_description_two"),
          t("blue_subsection_one_description_three"),
          t("blue_subsection_one_description_four"),
          t("blue_subsection_one_description_five"),
          t("blue_subsection_one_description_six"),
          t("blue_subsection_one_description_seven"),
          t("blue_subsection_one_description_eight"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("blue_chart", props) },
      {
        title: t("blue_subsection_two_title"),
        description: [
          t("blue_subsection_two_description_one"),
          t("blue_subsection_two_description_two"),
        ],
        positionText: "right",
      },
      {
        title: t("blue_subsection_three_title"),
        description: [
          t("blue_subsection_three_description_one"),
          t("blue_subsection_three_description_two"),
        ],
        positionText: "right",
      },
    ],
  },
  {
    title: t("blue_section_two_title"),
    subSections: [
      {
        title: t("blue_subsection_two_one_title"),
        description: [
          t("blue_subsection_two_one_description_one"),
          t("blue_subsection_two_one_description_two"),
        ],
        image: postawaImage,
        positionText: "right",
      },
      {
        title: t("blue_subsection_two_two_title"),
        description: [
          t("blue_subsection_two_two_description_one"),
          t("blue_subsection_two_two_description_two"),
        ],
        image: chodImage,
      },
      {
        title: t("blue_subsection_two_three_title"),
        description: [
          t("blue_subsection_two_three_description_one"),
          t("blue_subsection_two_three_description_two"),
          t("blue_subsection_two_three_description_three"),
          t("blue_subsection_two_three_description_four"),
        ],
        image: gestImage,
        positionText: "right",
      },
      {
        title: t("blue_subsection_two_four_title"),
        description: [
          t("blue_subsection_two_four_description_one"),
          t("blue_subsection_two_four_description_two"),
          t("blue_subsection_two_four_description_three"),
          t("blue_subsection_two_four_description_four"),
          t("blue_subsection_two_four_description_five"),
          t("blue_subsection_two_four_description_six"),
        ],
        image: mowaImage,
      },
    ],
  },
  {
    title: t("blue_section_three_title"),
    subSections: [
      {
        title: t("blue_subsection_three_one_title"),
        description: [
          t("blue_subsection_three_one_description_one"),
          t("blue_subsection_three_one_description_two"),
          t("blue_subsection_three_one_description_three"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("blueInStress_chart", props) },
      {
        title: t("blue_subsection_three_two_title"),
        description: [
          t("blue_subsection_three_two_description_one"),
          t("blue_subsection_three_two_description_two"),
          t("blue_subsection_three_two_description_three"),
        ],
        positionText: "right",
      },
      {
        title: t("blue_subsection_three_three_title"),
        description: [
          t("blue_subsection_three_three_description_one"),
          t("blue_subsection_three_three_description_two"),
        ],
        positionText: "right",
      },
    ],
  },
  {
    title: t("blue_section_four_title"),
    subSections: [
      {
        description1: t("blue_subsection_four_one_description1_one"),
        description2: t("blue_subsection_four_one_description2_two"),
      },
      { image: (props) => tImage("team_image", props) },
    ],
  },
  {
    title: t("blue_section_five_title"),
    subSections: [
      {
        title: t("blue_subsection_five_one_title"),
        description: t("blue_subsection_five_one_description_one"),
        isOneAboveAnother: true,
      },
      {
        title: t("blue_subsection_five_two_title"),
        description: [
          t("blue_subsection_five_two_description_one"),
          t("blue_subsection_five_two_description_two"),
          t("blue_subsection_five_two_description_three"),
          t("blue_subsection_five_two_description_four"),
        ],
        positionText: "right",
      },
      { image: (props) => tImage("communication_image", props) },
      {
        title: t("blue_subsection_five_three_title"),
        description: [
          t("blue_subsection_five_three_description_one"),
          t("blue_subsection_five_three_description_two"),
          t("blue_subsection_five_three_description_three"),
          t("blue_subsection_five_three_description_four"),
        ],
      },
    ],
  },
  {
    title: t("blue_section_six_title"),
    subSections: [
      {
        title: t("blue_subsection_six_one_title"),
        description: true,
      },
      {
        title: t("blue_subsection_six_two_title"),
        description: [
          t("blue_subsection_six_two_description_one"),
          t("blue_subsection_six_two_description_two"),
          ,
          t("blue_subsection_six_two_description_three"),
          ,
          t("blue_subsection_six_two_description_four"),
          ,
          t("blue_subsection_six_two_description_five"),
          ,
          t("blue_subsection_six_two_description_six"),
          ,
          t("blue_subsection_six_two_description_seven"),
          ,
          t("blue_subsection_six_two_description_eight"),
          ,
          t("blue_subsection_six_two_description_nine"),
          ,
          t("blue_subsection_six_two_description_ten"),
          ,
        ],
        image: bluered,
        positionText: "right",
      },
      {
        title: t("blue_subsection_six_three_title"),
        description: [
          t("blue_subsection_six_three_description_one"),
          t("blue_subsection_six_three_description_two"),
          t("blue_subsection_six_three_description_three"),
          t("blue_subsection_six_three_description_four"),
          t("blue_subsection_six_three_description_five"),
          t("blue_subsection_six_three_description_six"),
          t("blue_subsection_six_three_description_seven"),
          t("blue_subsection_six_three_description_eight"),
          t("blue_subsection_six_three_description_nine"),
          t("blue_subsection_six_three_description_ten"),
        ],
        image: blueyellow,
        positionText: "right",
      },
      {
        title: t("blue_subsection_six_four_title"),
        description: [
          t("blue_subsection_six_four_description_one"),
          t("blue_subsection_six_four_description_two"),
        ],
        image: blueblue,
        positionText: "right",
      },
      {
        title: t("blue_subsection_six_five_title"),
        description: [
          t("blue_subsection_six_five_description_one"),
          t("blue_subsection_six_five_description_two"),
          t("blue_subsection_six_five_description_three"),
          t("blue_subsection_six_five_description_four"),
          t("blue_subsection_six_five_description_five"),
          t("blue_subsection_six_five_description_six"),
          t("blue_subsection_six_five_description_seven"),
        ],
        image: bluegreen,
        positionText: "right",
      },
    ],
  },
];
